import { postMobileMessage } from "./postMobileMessage";

type TChannelBackProps = { isMobileAuth: boolean; onWebBack: VoidFunction };

export function handleChannelBack({ isMobileAuth, onWebBack }: TChannelBackProps) {
  if (isMobileAuth) {
    postMobileMessage("FLOW_CANCELLED");
    return;
  }

  onWebBack();
}
